exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boxBorder{\n  margin-bottom: 10px;\n  border-radius: 10px;\n  width: 500px;\n\n}\n\n.timestamp {\n  font-size: 12px;\n\n}\n\n.line {\n  margin-bottom: 8px;\n}\n\n.w3-badge,.w3-tag{background-color:rgb(91,206,179);color:#fff;display:inline-block;padding-left:8px;padding-right:8px;text-align:center}\n\n.w3-badge{border-radius:50%}\n\n@media screen and (max-width: 500px) {\n  .card-footer {\n    font-size: 70%;\n  }\n\n .mobileTitle {\n    font-size: 16px;\n  }\n\n  .mobileSub {\n    font-size: 12px;\n  }\n\n  .content{\n    font-size: 80%;\n  }\n\n  .timestamp {\n    font-size: 60%;\n  }\n\n  .card-content {\n    padding-bottom: 10px;\n  }\n\n\n }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/messaging/message-list/message-list.component.css
// module id = ../../../../../src/app/components/messaging/message-list/message-list.component.css
// module chunks = main